import { terms } from './constants';

export const getDirection = (current, prior) => {
    if (current !== undefined && prior !== undefined && prior !== 0) {
        const percentChange = ((current - prior) / prior) * 100;

        if (percentChange > 0) {
            return terms.upwardShift;
        }
        if (percentChange < 0) {
            return terms.downwardShift;
        }
        if (percentChange === 0) {
            return terms.noChange;
        }
    }
    return null;
};
